/**
 * Estilos CSS para o módulo Formulário Simples
 * Estilos isolados via Shadow DOM
 */

export function getFormularioSimplesStyles(config) {
    const { cssPrefix, color, colorButtonText, colorTitle, colorText, colorBackground, fontFamily } = config;

    return `
        :host {
            display: block;
            outline: none;
        }

        .${cssPrefix}-wrapper {
            width: 100%;
            font-family: ${fontFamily};
            box-sizing: border-box;
            padding: 0;
            margin: 0 auto;
            background: ${colorBackground};
        }

        .${cssPrefix}-card {
            width: 100%;
            max-width: 1280px;
            margin: 0 auto;
            border-radius: 0;
            padding: 50px 30px;
            box-sizing: border-box;
        }

        .${cssPrefix}-title {
            margin: 0;
            color: ${colorTitle};
            font-style: normal;
            font-weight: 700;
            font-size: 30px;
            line-height: 150%;
            letter-spacing: 0;
            text-align: center;
        }

        .${cssPrefix}-description {
            margin: 0 0 20px;
            color: ${colorText};
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 150%;
            letter-spacing: 0;
            text-align: center;
        }

        .${cssPrefix}-form {
            display: grid;
            grid-template-columns: minmax(0, 1.8fr) minmax(220px, 1fr) minmax(180px, auto);
            gap: 0.875rem;
            align-items: start;
        }

        .${cssPrefix}-field-group {
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
        }

        .${cssPrefix}-submit-group {
            justify-content: flex-start;
        }

        .${cssPrefix}-field-group label {
            font-size: 0.875rem;
            color: ${colorText};
            font-weight: 500;
        }

        .${cssPrefix}-form input,
        .${cssPrefix}-form select {
            width: 100%;
            height: 2.75rem;
            border: 1px solid #cfd7e3;
            border-radius: 4px;
            padding: 0 0.85rem;
            box-sizing: border-box;
            font-size: 0.95rem;
            color: #6b7280;
            background: #fff;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .${cssPrefix}-form input::placeholder {
            color: #9ca3af;
        }

        .${cssPrefix}-form input:focus,
        .${cssPrefix}-form select:focus {
            outline: none;
            border-color: ${color};
            box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.18);
        }

        .${cssPrefix}-error {
            min-height: 1rem;
            color: #dc2626;
            font-size: 0.8rem;
            line-height: 1.2;
        }

        .${cssPrefix}-form .${cssPrefix}-submit {
            width: 100%;
            height: 2.9rem;
            border: none;
            border-radius: 4px;
            background: ${color};
            color: ${colorButtonText || '#fff'};
            font-size: 0.95rem;
            font-weight: 700;
            cursor: pointer;
            transition: opacity 0.2s ease;
            align-self: stretch;
            white-space: nowrap;
        }

        .${cssPrefix}-submit-spacer {
            visibility: hidden;
        }

        .${cssPrefix}-form .${cssPrefix}-submit:hover {
            opacity: 0.9;
        }

        .${cssPrefix}-form .${cssPrefix}-submit:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .${cssPrefix}-message {
            margin-top: 0.85rem;
            border-radius: 0.5rem;
            padding: 0.65rem 0.75rem;
            font-size: 0.85rem;
            display: none;
        }

        .${cssPrefix}-message.success {
            display: block;
            background: #00a99d;
            color: #fff;
        }

        .${cssPrefix}-message.error {
            display: block;
            background: #dc2626;
            color: #fff;
        }

        @media (max-width: 768px) {
            .${cssPrefix}-wrapper {
                padding: 0;
            }

            .${cssPrefix}-card {
                padding: 50px 30px;
                border-radius: 0;
            }

            .${cssPrefix}-form {
                grid-template-columns: 1fr;
            }

            .${cssPrefix}-title {
                font-size: 24px;
            }
        }
    `;
}
